export default "__VITE_ASSET__DasjUt_h__"